<template>
  <fragment>
    <div class="col x-5">
      <build-carousel :custom-build="item.build"/>
    </div>
    <div class="col x-7">
      <div class="d-flex">
        <p class="yourBag__name"> {{ buildTitle(item.build) }}</p>
        <div class="select-primary-wrap">
          <v-select
              v-model="items[index]['qty']"
              :options="qtyOptions"
              class="select-primary"
              @input="changeQuantity($event, items[index])"
              @option:selecting="checkTenPlus"
          />
          <p v-if="showMaxQTYPopup"
             class="buyMore">
            {{ trans['contact_for_more'] }}
            <a :ref="`contact-via-${index}`"
               class="email-link"
               href="mailto:contact@forestal.com"
               @click.prevent="copyEmail(index)">contact@forestal.com</a>
            {{ trans['contact_for_more_end'] }}
          </p>
        </div>
        <div class="abs-wrap">
          <p class="yourBag__price">
            {{ itemSubTotal(items[index]) }}
            <span>{{ purchaseType(items[index]) }}</span>
          </p>
          <button
              class="btn btn-link"
              type="button"
              @click="removeItem(item)"
          >
            {{ trans.remove }}
          </button>
        </div>

        <div v-if="buildDescription(item.build)" class="w-100">
          <p class="yourBag__text">
            {{ buildDescription(item.build) }}
          </p>
        </div>

        <ul :class="{open: item.showFullSpecs}" class="yourBag__list">
          <li v-for="spec in getSpecs(item)" :key="spec.id">
            <strong>{{ trans[spec['common_title']] }}</strong> - {{ spec.title }}
          </li>
        </ul>

        <button
            v-if="showMoreBtn(item)"
            class="btn btn-link"
            type="button"
            @click="openList(index)">
          <span v-if="!item.showFullSpecs" class="more">
            {{ trans['show_more'] }}
          </span>
          <span v-if="item.showFullSpecs" class="less">
            {{ trans['show_less'] }}
          </span>
          <svg
              class="arr"
              fill="none"
              height="12"
              viewBox="0 0 14 9"
              width="12"
              xmlns="http://www.w3.org/2000/svg"
          >
            <path
                d="M1 0.999999L7 7L13 1"
                stroke="black"
                stroke-width="2"
            />
          </svg>
        </button>

        <hr/>

        <div v-if="getIncludedInDelivery(item).length > 0" class="includedDelivery">
          <p class="fs-20">
            {{ trans['included_in_delivery'] }}
          </p>

          <div class="flex-wrapper">
            <div
                v-for="item in getIncludedInDelivery(item)"
                :key="item.id"
                class="item">
              <div v-if="item.type === 'image_and_text'" class="img-wrap">
                <img :alt="item.title || item.text" :src="item.file"/>
              </div>
              <p v-if="item.type === 'image_and_text'" class="text">
                {{ item.title }}
              </p>

              <div v-if="item.type === 'accessories_box'" class="img-wrap">
                <img :alt="item.title || item.text" src="/assets/images/builds/accessoriesID.png"/>
              </div>
              <p v-if="item.type === 'accessories_box'" class="text">
                {{ trans['accessories_box'] }}

                <button
                    class="btn btn-link light"
                    type="button"
                    @click.prevent="showAccessoriesModal(item.text)"
                >
                  {{ trans['learn_more'] }}
                  <svg
                      class="arr"
                      fill="none"
                      height="12"
                      viewBox="0 0 14 9"
                      width="12"
                      xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                        d="M1 0.999999L7 7L13 1"
                        stroke="black"
                        stroke-width="2"
                    />
                  </svg>
                </button>
              </p>

              <div v-if="item.type === 'users_manual'" class="img-wrap">
                <img :alt="item.title || item.text" src="/assets/images/builds/manualsID.png"/>
              </div>
              <p v-if="item.type === 'users_manual'" class="text">
                {{ trans['user_manuals'] }}
                <a v-if="false" :href="item.file" class="btn btn-link light" download target="_blank">
                  {{ trans.download }}
                  <svg
                      class="download"
                      fill="none"
                      height="14"
                      viewBox="0 0 14 14"
                      width="14"
                      xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                        d="M2 4.06055L7 9.06055L12 4.06055"
                        stroke="black"
                        stroke-width="1.5"
                    />
                    <path
                        d="M7 8.06055L7 1.06055"
                        stroke="black"
                        stroke-width="1.5"
                    />
                    <path
                        d="M1 11.5605L13 11.5605"
                        stroke="black"
                        stroke-width="1.5"
                    />
                  </svg>
                </a>
              </p>

              <div v-if="item.type === 'securing_strap'" class="img-wrap">
                <a class="no-pointer" href="#" @click.prevent="noClick">
                  <img :alt="item.title || item.text" src="/assets/images/builds/strapID.png"/>
                </a>
              </div>
              <p v-if="item.type === 'securing_strap'" class="text">
                {{ trans['securing_strap'] }}
              </p>
            </div>
          </div>
          <hr/>
        </div>

        <div v-if="false" class="additionallyBox">
          <p v-if="noPart" class="fs-20">
            {{ trans['extra_options'] }}
          </p>
          <div v-if="noPart" class="d-flex">
            <div v-if="hasPedals(item)">
              <div v-for="pedal in pedals(item)" :ref="`pedal-${pedal.id}`" class="item added">
                <div class="addWrap">
                  <div class="img-wrap">
                    <img :alt="pedal['web_bike_title']" :src="extraImage(pedal)"/>
                  </div>
                  <div class="text-wrap">
                    <p class="title">
                      {{ pedal['web_bike_title'] }}
                      <span class="text">{{ pedal['short_description'] }}</span>
                    </p>
                    <p class="price">
                      {{ $crConverter(pedal['prices']['price_for_eu'] / 100, 'EUR', '%s +%v') }}
                    </p>
                    <button
                        class="btn btn-link light"
                        type="button"
                        @click="togglePedalInfoByRef(pedal)"
                    >
                      {{ trans['learn_more'] }}
                      <svg
                          class="arr"
                          fill="none"
                          height="12"
                          viewBox="0 0 14 9"
                          width="12"
                          xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                            d="M1 0.999999L7 7L13 1"
                            stroke="black"
                            stroke-width="2"
                        />
                      </svg>
                    </button>
                    <div class="inputSpinner">
                      <button
                          :disabled="pedal.qty === 1"
                          class="minus"
                          @click.prevent="changeExtraQuantity(pedal, item, false)"
                      >
                        <svg
                            fill="none"
                            height="25"
                            viewBox="0 0 24 25"
                            width="24"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                              d="M17 12.5H7"
                              stroke="black"
                              stroke-opacity="0.3"
                              stroke-width="2"
                          />
                        </svg>
                      </button>
                      <input
                          :title="trans['pedal_count']"
                          :value="pedal.qty"
                          max="10"
                          min="1"
                          step="1"
                          type="number"
                      />
                      <button
                          class="plus"
                          @click.prevent="changeExtraQuantity(pedal, item)"
                      >
                        <svg
                            fill="none"
                            height="25"
                            viewBox="0 0 24 25"
                            width="24"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                              d="M12 7.5V17.5M17 12.5H7"
                              stroke="black"
                              stroke-opacity="0.3"
                              stroke-width="2"
                          />
                        </svg>
                      </button>
                    </div>
                    <button
                        class="btn btn-link remove"
                        @click="removeExtra(pedal, item)"
                    >
                      {{ trans.remove }}
                    </button>
                    <div class="hiddenText">
                      <p>
                        {{ pedal['description'] }}
                      </p>
                      <a v-if="false" class="link" href="#">
                        {{ trans['basic_provisions'] }}
                      </a>
                    </div>
                    <p class="buyMore">
                      {{ trans['contact_for_more'] }}
                      <a href="mailto:contact@forestal.com">contact@forestal.com</a>
                      {{ trans['contact_for_more_end'] }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <button
                v-if="hasPedals(item)"
                class="btn btn-outline"
                @click="togglePedalModal(item)"
            >
              {{ addPedalText }}
            </button>
            <div v-if="!hasPedals(item) && hasAvailablePedals(item)" class="item">
              <div :class="{shown: pedalInfo}" class="addWrap">
                <div class="img-wrap">
                  <img alt="" src="/assets/images/builds/peel-ic.jpg"/>
                </div>
                <div class="text-wrap">
                  <p class="title">
                    {{ trans['add_more_pedals'] }}
                    <span class="text">
                      {{ trans['add_spare_pedals'] }}
                    </span>
                  </p>
                  <p class="price">
                    <span class="from">from</span>
                    {{ $crConverter(pedalMinPrice / 100, 'EUR', '%s +%v') }}
                  </p>
                  <button
                      class="btn btn-link light"
                      type="button"
                      @click="togglePedalInfo"
                  >
                    {{ trans['learn_more'] }}
                    <svg
                        class="arr"
                        fill="none"
                        height="12"
                        viewBox="0 0 14 9"
                        width="12"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                          d="M1 0.999999L7 7L13 1"
                          stroke="black"
                          stroke-width="2"
                      />
                    </svg>
                  </button>
                  <button
                      class="btn btn-green"
                      @click="togglePedalModal(item)"
                  >
                    {{ trans.add }}
                  </button>
                  <div class="hiddenText">
                    <p>
                      {{ trans['additional_owner_info'] }}
                    </p>
                    <a v-if="false" class="link" href="#">
                      {{ trans['basic_provisions'] }}
                    </a>
                  </div>
                  <p class="buyMore">
                    {{ trans['contact_for_more'] }}
                    <a href="#">contact@forestal.com</a>
                    {{ trans['contact_for_more_end'] }}
                  </p>
                </div>
              </div>
            </div>
            <div v-if="false">
              <div class="item">
                <div class="addWrap">
                  <div class="img-wrap">
                    <img alt="" src="/assets/images/builds/battery-ic.jpg"/>
                  </div>
                  <div class="text-wrap">
                    <p class="title">
                      {{ trans['battery_extender'] }}
                      <span class="text">350Wh, plus 1h 24min</span>
                    </p>
                    <p class="price">€ +199.00</p>
                    <button
                        class="btn btn-link light"
                        type="button"
                    >
                      {{ trans['learn_more'] }}
                      <svg
                          class="arr"
                          fill="none"
                          height="12"
                          viewBox="0 0 14 9"
                          width="12"
                          xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                            d="M1 0.999999L7 7L13 1"
                            stroke="black"
                            stroke-width="2"
                        />
                      </svg>
                    </button>
                    <button class="btn btn-green">
                      {{ trans.add }}
                    </button>
                    <div class="hiddenText">
                      <p>
                        {{ trans['additional_owner_info'] }}
                      </p>
                      <a class="link" href="#">
                        {{ trans['basic_provisions'] }}
                      </a>
                    </div>
                    <p class="buyMore">
                      {{ trans['contact_for_more'] }}
                      <a href="#">contact@forestal.com</a>
                      {{ trans['contact_for_more_end'] }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="item">
                <div class="addWrap">
                  <div class="img-wrap">
                    <img alt="" src="/assets/images/builds/guarantee-ic.jpg"/>
                  </div>
                  <div class="text-wrap">
                    <p class="title">
                      {{ trans['additional_guarantee'] }}
                      <span class="text">
                        {{ trans['plus_3_year'] }}
                      </span>
                    </p>
                    <p class="price">€ +399.00</p>
                    <button
                        class="btn btn-link light"
                        type="button"
                    >
                      {{ trans['learn_more'] }}
                      <svg
                          class="arr"
                          fill="none"
                          height="12"
                          viewBox="0 0 14 9"
                          width="12"
                          xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                            d="M1 0.999999L7 7L13 1"
                            stroke="black"
                            stroke-width="2"
                        />
                      </svg>
                    </button>
                    <button class="btn btn-green">
                      {{ trans.add }}
                    </button>
                    <div class="hiddenText">
                      <p>{{ trans['additional_owner_info'] }}</p>
                      <a class="link" href="#">
                        {{ trans['basic_provisions'] }}
                      </a>
                    </div>
                    <p class="buyMore">
                      {{ trans['contact_for_more'] }}
                      <a href="#">contact@forestal.com</a>
                      {{ trans['contact_for_more_end'] }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="item">
                <div class="addWrap">
                  <div class="img-wrap">
                    <img alt="" src="/assets/images/builds/bottle-cage-ic.jpg"/>
                  </div>
                  <div class="text-wrap">
                    <p class="title">
                      {{ trans['bottle_cage'] }}
                      <span class="text">
                        {{ trans['bottle_cage_info'] }}
                      </span>
                    </p>
                    <p class="price">€ +19.00</p>
                    <button
                        class="btn btn-link light"
                        type="button"
                    >
                      {{ trans['learn_more'] }}
                      <svg
                          class="arr"
                          fill="none"
                          height="12"
                          viewBox="0 0 14 9"
                          width="12"
                          xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                            d="M1 0.999999L7 7L13 1"
                            stroke="black"
                            stroke-width="2"
                        />
                      </svg>
                    </button>
                    <button class="btn btn-green">
                      {{ trans['add'] }}
                    </button>
                    <div class="hiddenText">
                      <p>{{ trans['additional_owner_info'] }}</p>
                      <a class="link" href="#">
                        {{ trans['basic_provisions'] }}
                      </a>
                    </div>
                    <p class="buyMore">
                      {{ trans['contact_for_more'] }}
                      <a href="#">contact@forestal.com</a>
                      {{ trans['contact_for_more_end'] }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="item">
                <div class="addWrap">
                  <div class="img-wrap">
                    <img alt="" src="/assets/images/builds/mudguard-set-ic.jpg"/>
                  </div>
                  <div class="text-wrap">
                    <p class="title">
                      {{ trans['mudguard_set'] }}
                      <span class="text">
                        {{ trans['mudguard_set_info'] }}
                      </span>
                    </p>
                    <p class="price">€ +29.00</p>
                    <button
                        class="btn btn-link light"
                        type="button"
                    >
                      {{ trans['learn_more'] }}
                      <svg
                          class="arr"
                          fill="none"
                          height="12"
                          viewBox="0 0 14 9"
                          width="12"
                          xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                            d="M1 0.999999L7 7L13 1"
                            stroke="black"
                            stroke-width="2"
                        />
                      </svg>
                    </button>
                    <button class="btn btn-green">
                      {{ trans.add }}
                    </button>
                    <div class="hiddenText">
                      <p>{{ trans['additional_owner_info'] }}</p>
                      <a class="link" href="#">
                        {{ trans['basic_provisions'] }}
                      </a>
                    </div>
                    <p class="buyMore">
                      {{ trans['contact_for_more'] }}
                      <a href="#">contact@forestal.com</a>
                      {{ trans['contact_for_more_end'] }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="delivery-text">
            <p class="fs-14">
              <strong>{{ trans['delivery_date_countries'] }}</strong> - {{ trans['delivery_default_date'] }}
            </p>
            <p class="fs-14">
              <strong>{{ trans['other_countries'] }}</strong> - {{ trans['delivery_date_other'] }}
            </p>
          </div>
          <hr/>
        </div>

        <delivery-options v-if="false"/>

        <div class="resultBox">
          <p class="fs-17">Subtotal <span>{{ itemSubTotal(item) }}</span></p>
          <p class="fs-17">
            {{ trans['delivery'] }} <span>{{ deliveryDate }}</span>
          </p>
          <p class="fs-12">
            * Direct shipping is available to countries in Europe (continent).
          </p>
          <p class="fs-12 mt-3-5">
            For rest of countries, please contact us at <a href="mailto:contact@forestal.com">contact@forestal.com</a>
          </p>
          <p class="fs-12 mt-3">Due to the extraordinary conditions with supply chain of third-party components, the
            displayed dates are subject to change.</p>
        </div>
      </div>
    </div>
  </fragment>
</template>

<script>
import BuildCarouselSync from "../../builds/parts/BuildCarouselSync";
import {mapGetters} from "vuex";
import VueSelect from "vue-select";
import DeliveryOptions from "./DeliveryOptions";

export default {
  name: "Item",
  props: ['item', 'index', 'pedalsList', 'trans'],
  components: {
    'delivery-options': DeliveryOptions,
    "build-carousel": BuildCarouselSync,
    "v-select": VueSelect,
  },
  computed: {
    ...mapGetters({
      items: 'baskets/items',
      showPedalModal: 'baskets/showPedalModal'
    }),
    qtyOptions() {
      let range = Array.from(Array(11).keys())
      range.shift()
      range.push('10+')
      return range
    },
    noPart() {
      return this.item.build.category.id !== 2
    },
    addPedalText() {
      return this.trans['add_other_pedals']
    },
    pedalMinPrice() {
      let min = null
      this.pedalsList.map(pedal => {
        if (min === null || pedal['prices']['price_for_eu'] < min) {
          min = pedal['prices']['price_for_eu']
        }
        return pedal
      })
      return min
    },
    deliveryDate() {
      const months = {
        1 : 'January',
        2 : 'February',
        3 : 'March',
        4 : 'April',
        5 : 'May',
        6 : 'June',
        7 : 'July',
        8 : 'August',
        9 : 'September',
        10 : 'October',
        11 : 'November',
        12 : 'December',
      };

      const defaultDate = this.$moment().add(3, 'month').format('MMMM YYYY')

      if (this.item && this.item.build) {
        if (this.item.build['delivery_date_parsed']) {
          return months[this.item.build['delivery_date_parsed']['month']] + ' ' + this.item.build['delivery_date_parsed']['year']
        } else if (this.item.build['model'] && this.item.build['model']['delivery_info']) {
          return this.item.build.model['delivery_info'] || defaultDate
        }
      }
      return defaultDate
    },
  },
  data() {
    return {
      pedalInfo: false,
      showMaxQTYPopup: false
    }
  },
  methods: {
    copyEmail(index) {
      this.$copyText('contact@forestal.com').then(() => {
        this.$refs[`contact-via-${index}`].classList.add('with-before')
        setTimeout(() => {
          this.$refs[`contact-via-${index}`].classList.remove('with-before')
        }, 2000)
      })
    },
    showAccessoriesModal(text) {
      this.$store.commit('changeModalTitle', 'The accessories box includes:')
      this.$store.commit('changeModalContent', text)
      this.$store.commit('changeModalType', 'list')
      this.$store.commit('changeModalStatus', true)
    },
    buildDescription(build) {
      return build['short_description'];
    },
    noClick() {
    },
    togglePedalInfoByRef(pedal) {
      let pedalBlock = this.$refs[`pedal-${pedal.id}`][0]
      let box = pedalBlock.getElementsByClassName('addWrap')
      if (box[0]) {
        if (box[0].classList.contains('shown')) {
          box[0].classList.remove('shown')
        } else {
          box[0].classList.add('shown')
        }
      }
    },
    togglePedalInfo() {
      this.pedalInfo = !this.pedalInfo
    },
    removedBuildTitle(build) {
      let title = [build['web_bike_title']]
      if (build.color) {
        title.push(build.color['title'])
      }
      if (build.size) {
        title.push(build.size['web_title'])
      }
      title.push('removed from your bag')
      return title.join(' ')
    },
    buildTitle(build) {
      let title = [build['web_bike_title']]
      if (build.size) {
        title.push(build.size['web_title'])
      }
      return title.join(' ')
    },
    checkTenPlus(event) {
      if (event === 10 && this.showMaxQTYPopup) {
        this.showMaxQTYPopup = false
      }
    },
    changeQuantity(qty, item, index) {
      if (qty === '10+') {
        qty = 10
        item.qty = 10
        this.showMaxQTYPopup = true
      } else {
        this.showMaxQTYPopup = false
      }
      let oldValue = item.qty
      this.$store.dispatch('baskets/changeBasketItemQTY', {
        path: this.$path,
        qty: qty,
        item: item.id,
      }).then(() => {
        this.$store.dispatch('baskets/count', {path: this.$path})
      }).catch(() => {
        this.$store.commit('baskets/changeLocalItemQTY', {
          index: index,
          qty: oldValue
        })
      })
    },
    itemSubTotal(item, convert = true) {
      let total
      let euCountry = item.build.country_taxes.find(country => {
        return country.vat === 21
      })
      if (item.purchase_type === 'full') {
        if (item['pre_sale_price']) {
          total = euCountry.ex_price * item.qty;
        } else {
          total = euCountry.price * item.qty;
        }
      } else {
        total = euCountry.res_price * item.qty;
      }
      item.extra.map(extra => {
        total += extra['prices']['price_tax_base'] * extra.qty
      })
      if (convert) {
        return this.$crConverter(total / 100, 'EUR')
      }

      return total
    },
    purchaseType(item) {
      if (item.purchase_type === 'reservation') {
        return this.trans['reservation_price'];
      } else if (item.purchase_type === 'full') {
        return this.trans['retail_price'];
      }
      return null;
    },
    removeItem(item) {
      this.$store.dispatch('baskets/removeItem', {
        path: this.$path,
        item: item.id,
      }).then(() => {
        this.$store.dispatch('baskets/count', {path: this.$path})
        this.$store.commit('baskets/setRemovedItem', {
          id: item.id,
          title: this.removedBuildTitle(item.build)
        })
        this.$store.commit('baskets/hideItem', item)
        localStorage.setItem('removedItem', item.id)
        localStorage.setItem('removedItemText', this.removedBuildTitle(item.build))
      }).catch()
    },
    getSpecs(item) {
      if (item.showFullSpecs) {
        return item.build.specs
      }

      return item.build.short_specs
    },
    showMoreBtn(item) {
      return item.build.specs.length > 9
    },
    openList(index) {
      this.$store.commit('baskets/toggleShowingFullSpecForOption', index);
    },
    getIncludedInDelivery(item) {
      return item.build['included_in_delivery']
    },
    pedals(item) {
      return item.extra.filter(item => {
        if (item['build_category']) {
          return item['build_category'].title === 'Pedals'
        } else {
          return item['sub_category'].title === 'Pedals'
        }
      }).map(item => {
        item.info = false
        return item
      })
    },
    hasPedals(item) {
      return this.pedals(item).length > 0
    },
    hasAvailablePedals(item) {
      for (let pedal of this.pedalsList) {
        let models = pedal.models
        if (models.length === 0 || models.find(model => {
          return model.id === item.build.model.id
        }) !== undefined) {
          return true
        }
      }
      return false;
    },
    togglePedalModal(item) {
      if (!this.showPedalModal) {
        this.$store.commit('baskets/setSelectedBasketItem', item)
      } else {
        this.$store.commit('baskets/setSelectedBasketItem', null)
      }
      this.$store.commit('baskets/togglePedalModal')
      if (this.showPedalModal) {
        document.getElementsByTagName('body')[0].classList.add('vh100')
      } else {
        document.getElementsByTagName('body')[0].classList.remove('vh100')
      }
    },
    getSubTotal(item) {
      return this.itemSubTotal(item)
    },
    changeExtraQuantity(extra, item, add = true) {
      this.$store.dispatch('baskets/changeExtraQTY', {
        path: this.$path,
        extra,
        item,
        add,
      }).then(() => {
        this.$store.commit('baskets/changeExtraQTY', {
          extra, item, add
        })
      }).catch((error) => {
        console.error(error)
      })
    },
    removeExtra(extra, item) {
      this.$store.dispatch('baskets/removeExtra', {
        path: this.$path,
        extra,
        item
      }).then(() => {
        this.$store.commit('baskets/removeExtra', {
          extra, item
        })
      })
    },
    extraImage(extra) {
      if (extra.media) {
        return extra.media.preview
      }

      return extra['media_content'].preview
    },
  }
}
</script>

<style lang="scss" scoped>
.email-link {
  position: relative;
  display: block;

  &.with-before {
    &:before {
      content: 'copied';
      position: absolute;
      top: 0;
      left: 0;
      width: 101%;
      background: #FFFFFF;
      text-align: left;
      display: block;
    }
  }
}

.mt-3-5 {
  margin-top: 0 !important;
}
</style>
